<template>
  <html id="printableArea" style="width:100%;overflow-y:visible">
    <head>
      <meta http-equiv="Content-Type" content="text/html; charset=utf-8"/>
      <title>Печать отчета</title>
    </head>
    <body>
      <div>
        <v-flex xs12 v-if="report">
          <v-card>
            <v-card-text>
              <center><h2>{{cafe}}</h2></center><br>
              <center>Сводный отчет за {{monthName}} {{month.split('-')[0]}} года</center><br>
              <table
                width="100%"
                border="1"
                cellpadding="0"
                cellspacing="0"
                style="font-size:8pt;border-collapse:collapse;"
                class="my-3"
              >
                <tr>
                  <th>Класс</th>
                  <th>Тип питания</th>
                  <th>Кол-во заявок</th>
                  <th>Сумма(руб)</th>
                </tr>
                <tr
                  v-for="item in report"
                  :key="`${item.positionid}${item.saletypeid}`"
                  style="text-align:center">
                  <td>{{item.positionname}}</td>
                  <td>{{item.saletype}}</td>
                  <td>{{parseInt(item.dayscount)}}</td>
                  <td>{{parseFloat(item.amount).toFixed(2)}}</td>
                </tr>
                <tr style="text-align:center">
                  <td>
                    <b>Итого</b>
                  </td>
                  <td></td>
                  <td>
                    <b>{{report.reduce((a, b) => a + parseInt(b.dayscount), 0)}}</b>
                  </td>
                  <td>
                    <b>{{report.reduce((a, b) => a + parseFloat(b.amount), 0).toFixed(2)}}</b>
                  </td>
                </tr>
              </table>
            </v-card-text>
            <br>
            <small v-if="report">Дата составления: {{ today }}</small>
          </v-card>
        </v-flex>
      </div>
    </body>
  </html>
</template>

<script>
import moment from 'moment'
import ExcelJS from 'exceljs'
export default {
  name: 'PSReportTable',
  props: [ 'headers', 'report', 'cafe', 'month' ],
  computed: {
    monthName () {
      moment.locale('ru')
      return moment.months()[parseInt(this.month.split('-')[1]) - 1]
    },
    today () {
      return moment().format('DD.MM.YYYY')
    }
  },
  methods: {
    async makeXLSX () {
      const workbook = new ExcelJS.Workbook()
      const sheet = workbook.addWorksheet('Сводный отчет по начальной школе')

      sheet.addRow(['Столовая 30'])
      sheet.mergeCells(1, 1, 1, 4)
      const cafeHeader = sheet.getCell(1, 1)
      cafeHeader.alignment = { vertical: 'middle', horizontal: 'center' }
      cafeHeader.font = { size: 14 }

      sheet.addRow([])
      sheet.addRow([`Сводный отчет за ${this.monthName} ${this.month.split('-')[0]} года`])
      sheet.mergeCells(3, 1, 3, 4)
      const reportHeader = sheet.getCell(3, 1)
      reportHeader.alignment = { vertical: 'middle', horizontal: 'center' }
      reportHeader.font = { size: 12 }
      sheet.addRow([])

      sheet.addRow(this.headers.map(h => h.text))
      for (const entry of this.report) {
        sheet.addRow([entry.positionname, entry.saletype, entry.dayscount, parseFloat(entry.amount)])
      }
      const totalRow = sheet.addRow(['Итого', '', this.report.reduce((acc, e) => acc + parseInt(e.dayscount), 0), this.report.reduce((acc, e) => parseFloat(acc + e.amount), 0)])
      totalRow.eachCell(cell => {
        cell.font = { bold: true }
      })

      const positionCol = sheet.getColumn(1)
      positionCol.width = 10
      const saletypeCol = sheet.getColumn(2)
      saletypeCol.width = 50
      const daysCountCol = sheet.getColumn(3)
      daysCountCol.width = 20
      const amountCol = sheet.getColumn(4)
      amountCol.width = 20

      const dateRow = sheet.addRow([`Дата составления: ${this.today}`])
      sheet.mergeCells(dateRow.number, 1, dateRow.number, 4)

      sheet.eachRow((row, rowNumber) => {
        row.eachCell((cell, colNumber) => {
          if (row.number > 4) {
            cell.border = {
              top: {
                style: 'thin'
              },
              left: {
                style: 'thin'
              },
              bottom: {
                style: 'thin'
              },
              right: {
                style: 'thin'
              }
            }
            cell.alignment = { vertical: 'middle', horizontal: 'left' }
            cell.protection = { locked: true }
          }
        })
      })

      await sheet.protect('123456', {
        selectLockedCells: true,
        selectUnlockedCells: true,
      })

      const buffer = await workbook.xlsx.writeBuffer()
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = 'tabel.xlsx'
      a.click()
      window.URL.revokeObjectURL(url)
    }
  }
}
</script>

<style lang="css" scoped>
</style>
